export const normalizePrice = (value) => {
  if (!value) {
    return value;
  }
  let wholePart = Math.floor(value);
  if (wholePart.toString().length > 13) {
    return value.slice(0, -1);
  }
  const regex = /^[0-9]*\.?[0-9]{0,2}$/;
  if (!regex.test(value)) {
    return value.slice(0, -1);
  }
  return value;
}
